export interface DatePositions {
  dayPost: number;
  monthPost: number;
  yearPost: number;
}
